const RESET_ENROLLMENT_WARNING =
    'If you wish to choose a different plan, you will be redirected to our Plan Options page, where you can search and discover the best plan for your needs. You will need to re-enter your information when you are ready to enroll. Would you like to continue?';
export { RESET_ENROLLMENT_WARNING };
